(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-room-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-aliguler-bundle]');
    if (!root) return;
    var total = root.querySelector('[data-bundle-total]');
    var label = root.querySelector('[data-bundle-total-label]');
    var value = root.querySelector('[data-bundle-total-value]');
    var perMo = root.querySelector('[data-bundle-per-mo]');
    var mixed = root.querySelector('[data-bundle-mixed]');
    var btn = root.querySelector('[data-bundle-add]');
    var status = root.querySelector('[data-bundle-status]');

    var T = {};
    try { T = JSON.parse(root.querySelector('[data-bundle-i18n]').textContent) || {}; } catch (e) { T = {}; }
    function tr(k, fb, n) { var s = T[k] || fb; return n == null ? s : s.split('%n').join(String(n)); }

    function money(cents) { return '$' + Math.round(cents / 100).toLocaleString('en-US'); }
    function rows() { return Array.prototype.slice.call(root.querySelectorAll('[data-bundle-row]')); }

    function refresh() {
      var count = 0, cents = 0, anyMto = false;
      rows().forEach(function (r) {
        var qty = parseInt(r.getAttribute('data-qty'), 10) || 0;
        var stock = parseInt(r.getAttribute('data-stock'), 10) || 0;
        var cap = parseInt(r.getAttribute('data-cap'), 10) || 0;
        var policy = r.getAttribute('data-policy');
        r.querySelector('[data-bundle-count]').textContent = qty;
        r.querySelector('[data-bundle-minus]').disabled = qty <= 0;
        r.querySelector('[data-bundle-plus]').disabled = qty >= cap;
        var note = r.querySelector('[data-bundle-note]');
        if (policy === 'continue' && stock > 0 && qty > stock) {
          note.textContent = tr('note', '%n in stock \u00b7 rest made to order, 12\u201316 weeks', stock);
          note.hidden = false; anyMto = true;
        } else { note.hidden = true; }
        if (qty > 0 && stock <= 0) anyMto = true;
        count += qty; cents += qty * (parseInt(r.getAttribute('data-price'), 10) || 0);
      });
      total.hidden = count === 0;
      if (count === 0) return;
      label.textContent = count === 1 ? tr('set_one', 'Your set \u00b7 %n piece', count) : tr('set_other', 'Your set \u00b7 %n pieces', count);
      value.textContent = money(cents);
      // AG 2026-09-17 (mobile audit #1): match the header and the sticky bar (deferred interest).
      perMo.textContent = tr('per_mo', 'or %n/mo \u00b7 12 mo. financing*', money(Math.floor(cents / 12)));
      mixed.hidden = !anyMto;
      btn.disabled = false;
      btn.textContent = count === 1 ? tr('add_one', 'Add %n piece', count) : tr('add_other', 'Add %n pieces', count);
    }

    root.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null; if (!t) return;
      var plus = t.closest('[data-bundle-plus]'), minus = t.closest('[data-bundle-minus]');
      if (plus || minus) {
        e.preventDefault();
        var r = (plus || minus).closest('[data-bundle-row]');
        var qty = parseInt(r.getAttribute('data-qty'), 10) || 0;
        var cap = parseInt(r.getAttribute('data-cap'), 10) || 0;
        if (plus && qty < cap) qty += 1;
        if (minus && qty > 0) qty -= 1;
        r.setAttribute('data-qty', qty);
        status.textContent = '';
        refresh();
        if (window.AGTrack && plus) window.AGTrack('ag_set_pick', { piece: r.getAttribute('data-name'), qty: qty });
        return;
      }
      if (t.closest('[data-bundle-add]')) {
        e.preventDefault();
        var items = [], names = [], count = 0;
        rows().forEach(function (r) {
          var q = parseInt(r.getAttribute('data-qty'), 10) || 0;
          if (q > 0) { items.push({ id: parseInt(r.getAttribute('data-variant-id'), 10), quantity: q }); names.push(r.getAttribute('data-name') + (q > 1 ? ' \u00d7 ' + q : '')); count += q; }
        });
        if (!items.length) return;
        btn.disabled = true; btn.textContent = tr('adding', 'Adding\u2026'); status.textContent = '';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) {
              status.textContent = (res.body && res.body.description) ? res.body.description : tr('err', 'Could not add to cart. Please try again.');
              refresh(); return;
            }
            return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
              document.querySelectorAll('[data-js-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
              status.innerHTML = tr('added', 'Added to cart: %names \u00b7 <a href="{{ ag_lp }}/cart">View cart \u2192</a>').split('%names').join(names.join(', ').replace(/</g, '&lt;'));
              refresh();
              if (window.AGTrack) window.AGTrack('ag_add_to_cart', { source: 'room_set', quantity: count });
            });
          })
          .catch(function () { status.textContent = tr('net', 'Network error. Please try again.'); refresh(); });
      }
    });

    /* While the set is on screen the sticky ADD TO CART bar must not sit under the row steppers:
       a missed "+" would add the sofa instead. theme.liquid hides the bar on body[data-ag-set="inview"]. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var inview = entries.some(function (en) { return en.isIntersecting; });
        if (inview) document.body.setAttribute('data-ag-set', 'inview'); else document.body.removeAttribute('data-ag-set');
      }, { rootMargin: '-80px 0px -60px 0px' }).observe(root);
    }
    refresh();
  })();
  } catch(e) { console.error(e); }
})();

})();
